import { render, staticRenderFns } from "./matchingInfoSetting.vue?vue&type=template&id=501aec10"
import script from "./matchingInfoSetting.vue?vue&type=script&lang=js"
export * from "./matchingInfoSetting.vue?vue&type=script&lang=js"
import style0 from "./matchingInfoSetting.vue?vue&type=style&index=0&id=501aec10&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports